module.exports = __webpack_public_path__ + "static/img/2.0d846b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/1/2.png
// module id = 05nC
// module chunks = 1